import { Component, OnInit } from '@angular/core';
import { AnalyseService } from 'src/app/services/analyse-service';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ActivatedRoute, Router } from '@angular/router';
import { Analyse } from 'src/app/domain/Analyse/analyse';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-notation',
    templateUrl: './notation.component.html',
    styleUrls: ['./notation.component.scss']
})
export class NotationComponent implements OnInit {

    Analysis: Analyse = new Analyse();

    constructor(
        private analyseService: AnalyseService,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute,
        private router: Router) { }

    ngOnInit(): void {
        if (!this.route.snapshot.params.code) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        this.analyseService.getAnalyseByCode(this.route.snapshot.params.code).subscribe(x => {
            this.Analysis = x;
        });
    }

    canSave() {
        if (this.Analysis.Interpretation) {
            return true;
        }
        return false;
    }

    save() {
        this.analyseService.sendInterpretation(this.Analysis).subscribe(x => {
            NotificationManager.handleSuccess('Interprétation sauvegardée', this.snackBar);
        });
    }
}
